import type { MapViewData } from "@/lib/aiWidgetMapParser"
import type { TachoCard } from "@/lib/aiWidgetTachoParser"
import type { OrderCard } from "@/lib/aiWidgetOrderParser"
import type { AgentTurn, FinishedTurn } from "@/reducers/agentPipelineSlice"

/**
 * What useAIChatRuntime attaches to a thread message for AIChatMessage. The
 * runtime is the only writer, so the message never reads the store itself.
 */
export type AIChatMessageMeta = {
  aiWidgetMap?: MapViewData
  aiWidgetTacho?: TachoCard
  aiWidgetOrder?: OrderCard
  // Only on the placeholder for the turn the agent is working on now.
  turn?: AgentTurn
  // Only on an answer whose turn had steps.
  summary?: FinishedTurn
}

export const readMessageMeta = (message: {
  metadata?: { custom?: Record<string, unknown> }
}): AIChatMessageMeta => (message.metadata?.custom ?? {}) as AIChatMessageMeta
